import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";
import ModelContainer from "../../../../Components/ModelContainer";
import Select from "../../../../Components/Select";
import Input from "../../../../Components/Input";
import ListDateInput from "../../../../Components/ListDateInput";
import Checkbox from "../../../../Components/Checkbox";
import ErrorContainer from "../../../../Components/ErrorContainer";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DatePicker from "react-date-picker";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../../Redux";
import DateInput from "../../../../Components/DateInput";
import { getFormData } from "../../../../../helpers";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LocalHeader from "./LocalHeader";
import TimeInput from "../../../../Components/TimeInput";

const DeliveryPartner = () => {
  const dispatch = useDispatch();

  const [modalType, setModalType] = useState("add");
  const [editData, setEditData] = useState(null);
  const showModal = useSelector(
    (state) => state?.settingReducer.deliveryPartnerModal
  );
  const setShowModal = (formState) =>
    dispatch(
      actions?.setFormState({ formName: "deliveryPartnerModal", formState })
    );

  const deliveryPartnerData = useSelector(
    (state) => state?.settingReducer?.deliveryPartnerData?.order_online
  );

  const deliveryPartnerOptions = useSelector(
    (state) => state?.settingReducer?.deliveryPartnerData
  );

  const [sectionHide, setSectionHide] = useState({
    enableDeliveryType: false,
    enableDeliveryPartner: false,
    deliveryFeeBasis: false,
  });
  useEffect(() => {
    dispatch(actions?.getDeliveryPartnerData());
  }, []);

  useEffect(() => {
    setSectionHide({
      enableDeliveryType:
        deliveryPartnerData?.enable_delivery_order_type === "yes"
          ? true
          : false,
      enableDeliveryPartner:
        deliveryPartnerData?.enable_delivery_partner === "yes" ? true : false,
      deliveryFeeBasis: deliveryPartnerData?.delivery_fee_basis?.toString(),
    });
    console.log(deliveryPartnerDefaultState, "deliveryPartnerDefaultState");
    deliveryPartnerReset(deliveryPartnerDefaultState);
  }, [deliveryPartnerData]);
  const deliveryPartnerDefaultState = {
    enable_delivery_order_type:
      deliveryPartnerData?.enable_delivery_order_type ?? "",
    enable_delivery_partner: deliveryPartnerData?.enable_delivery_partner ?? "",
    delivery_services_radius:
      deliveryPartnerData?.delivery_services_radius ?? "",
    delivery_fee_charged: deliveryPartnerData?.delivery_fee_charged ?? "",
    delivery_fee_basis: deliveryPartnerData?.delivery_fee_basis ?? "",
    fixed_fee: deliveryPartnerData?.fixed_fee ?? "",
    cost_per_km: deliveryPartnerData?.cost_per_km ?? "",
    delivery_cost_payment_account_id:
      deliveryPartnerData?.delivery_cost_payment_account_id ?? "",
    own_delivery_estimate: deliveryPartnerData?.own_delivery_estimate ?? "",
    preferred_delivery_partner_rule:
      deliveryPartnerData?.preferred_delivery_partner_rule ?? "",
    preferred_delivery_partner:
      deliveryPartnerData?.preferred_delivery_partner ?? "",
    partner_delivery_estimate:
      deliveryPartnerData?.partner_delivery_estimate ?? "",
  };
  const deliveryPartnerSchema = yup.object({
    enable_delivery_order_type: yup.string().required(),
    enable_delivery_partner: sectionHide?.enableDeliveryType
      ? yup.string().required()
      : yup.string(),
    delivery_services_radius: sectionHide?.enableDeliveryType
      ? yup.string().required()
      : yup.string(),
    delivery_fee_charged: sectionHide?.enableDeliveryType
      ? yup.string().required()
      : yup.string(),
    delivery_fee_basis: sectionHide?.enableDeliveryType
      ? yup.string().required()
      : yup.string(),
    fixed_fee:
      sectionHide?.enableDeliveryType && sectionHide?.deliveryFeeBasis === "1"
        ? yup.string().required()
        : yup.string(),
    cost_per_km:
      sectionHide?.enableDeliveryType && sectionHide?.deliveryFeeBasis === "2"
        ? yup.string().required()
        : yup.string(),
    delivery_cost_payment_account_id: sectionHide?.enableDeliveryType
      ? yup.string().required()
      : yup.string(),
    own_delivery_estimate: sectionHide?.enableDeliveryType
      ? yup.string().required()
      : yup.string(),
    preferred_delivery_partner_rule: sectionHide?.enableDeliveryType
      ? yup.string().required()
      : yup.string(),
    preferred_delivery_partner: sectionHide?.enableDeliveryType
      ? yup.string().required()
      : yup.string(),
    partner_delivery_estimate: sectionHide?.enableDeliveryType
      ? yup.string().required()
      : yup.string(),
  });
  const {
    register: deliveryPartnerRegister,
    formState: { errors: deliveryPartnerError },
    handleSubmit: deliveryPartnerSubmit,
    reset: deliveryPartnerReset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(deliveryPartnerSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: deliveryPartnerDefaultState,
  });

  function submitData(data) {
    console.log(data, "nnnnnnn");
    dispatch(actions?.postDeliveryPartnerData(data));
  }
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 mt-3">
          <div className="container px-0">
            <LocalHeader />

            <div class="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="general"
                role="tabpanel"
                aria-labelledby="general-tab"
              >
                <div className="row lbrSettingMs d-flex">
                  <div className="col-md-12 modify">
                    <div className="shadowclass mt-md-4 mt-3 d-flex flex-wrap align-content-start">
                      <h4 className="event-alert w-100 mb-4">
                        Delivery Settings
                      </h4>
                      <div className="d-flex calc-height w-100 flex-wrap">
                        <div className="settings-left-content fixed-pos col-3">
                          <ul className="settingMenus">
                            <li id="AccDetail_li" className="active">
                              <a href="#_" id="AccDetail_dayTime_a">
                                GENERAL
                              </a>
                            </li>

                            {sectionHide?.enableDeliveryType && (
                              <li id="FinSettings_li" className="">
                                <a href="#_" id="FinSettings_dayTime_a">
                                  OWN DELIVERY SETTINGS
                                </a>
                              </li>
                            )}
                            <li id="AccDetail_li" className="active">
                              <a href="#_" id="AccDetail_dayTime_a">
                                DELIVERY PARTNER SETTINGS
                              </a>
                            </li>
                          </ul>
                        </div>

                        <div className="settings-right-content scrolling col-9">
                          <form onSubmit={deliveryPartnerSubmit(submitData)}>
                            {console.log(deliveryPartnerError)}
                            <div className="date-sec-scroll">
                              <div
                                id="AccDetail_dayTime_div"
                                className="row-fluid scroll-change full_div"
                                day_time="AccDetail"
                              >
                                <div className="form-secs">
                                  <h4> General </h4>
                                  <ul class="ingredient-info edit-shift">
                                    <Select
                                      label={"Enable Delivery Order Type"}
                                      formRegister={deliveryPartnerRegister}
                                      formError={deliveryPartnerError}
                                      formKey={"enable_delivery_order_type"}
                                      optionsArray={
                                        deliveryPartnerOptions?.yes_no
                                      }
                                      onChange={(e) => {
                                        setSectionHide({
                                          ...sectionHide,
                                          enableDeliveryType:
                                            e.target.value === "yes"
                                              ? true
                                              : false,
                                        });
                                      }}
                                    />

                                    <Select
                                      label={"Enable Delivery Partners?"}
                                      formRegister={deliveryPartnerRegister}
                                      formError={deliveryPartnerError}
                                      formKey={"enable_delivery_partner"}
                                      optionsArray={
                                        deliveryPartnerOptions?.yes_no
                                      }
                                      onChange={(e) => {
                                        setSectionHide({
                                          ...sectionHide,
                                          enableDeliveryPartner:
                                            e.target.value === "yes"
                                              ? true
                                              : false,
                                        });
                                      }}
                                    />
                                  </ul>
                                </div>
                              </div>
                              {sectionHide?.enableDeliveryType && (
                                <>
                                  <div
                                    id="FinSettings_dayTime_div"
                                    className="row-fluid scroll-change full_div"
                                    day_time="FinSettings"
                                  >
                                    <div className="form-secs">
                                      <h4>Own Delivery Settings</h4>
                                      <ul class="ingredient-info edit-shift d-flex">
                                        <Input
                                          label={"Default Order Station"}
                                          formRegister={deliveryPartnerRegister}
                                          formError={deliveryPartnerError}
                                          formKey={"delivery_services_radius"}
                                        />
                                        {/* <Select
                                          label={"Own Delivery Fee Charged? "}
                                          formRegister={deliveryPartnerRegister}
                                          formError={deliveryPartnerError}
                                          formKey={"delivery_fee_charged"}
                                          optionsArray={
                                            deliveryPartnerOptions?.yes_no
                                          }
                                        /> */}

                                        {/* <Select
                                          label={"Own Delivery Fee Basis "}
                                          formRegister={deliveryPartnerRegister}
                                          formError={deliveryPartnerError}
                                          formKey={"delivery_fee_basis"}
                                          optionsArray={[
                                            { value: "1", label: "Fixed Fee" },
                                            {
                                              value: "2",
                                              label: "Cost Per Km",
                                            },
                                            { value: "3", label: "Manual" },
                                          ]}
                                          onChange={(e) => {
                                            setSectionHide({
                                              ...sectionHide,
                                              deliveryFeeBasis: e.target?.value,
                                            });
                                          }}
                                        /> */}
                                        {sectionHide?.deliveryFeeBasis !==
                                          "3" && (
                                          <Input
                                            label={
                                              sectionHide?.deliveryFeeBasis ===
                                              "1"
                                                ? "Fixed Fee"
                                                : "Cost Per Km"
                                            }
                                            formRegister={
                                              deliveryPartnerRegister
                                            }
                                            formError={deliveryPartnerError}
                                            formKey={
                                              sectionHide?.deliveryFeeBasis ===
                                              "1"
                                                ? "fixed_fee"
                                                : "cost_per_km"
                                            }
                                          />
                                        )}
                                        <Select
                                          label={
                                            "Defualt Own Delivery Cost Payment Account"
                                          }
                                          formRegister={deliveryPartnerRegister}
                                          formError={deliveryPartnerError}
                                          formKey={
                                            "delivery_cost_payment_account_id"
                                          }
                                          optionsArray={deliveryPartnerOptions?.cash_ap_liability?.map(
                                            (el, idx) => ({
                                              value: idx,
                                              label: el,
                                            })
                                          )}
                                        />
                                        <Input
                                          label={
                                            "Default Own Delivery Estimate (Mins)"
                                          }
                                          formRegister={deliveryPartnerRegister}
                                          formError={deliveryPartnerError}
                                          formKey={"own_delivery_estimate"}
                                        />
                                      </ul>
                                    </div>
                                  </div>
                                  <div
                                    id="FinSettings_dayTime_div"
                                    className="row-fluid scroll-change full_div"
                                    day_time="FinSettings"
                                  >
                                    <div className="form-secs">
                                      <h4>Delivery Partner Settings</h4>
                                      <ul class="ingredient-info edit-shift d-flex">
                                        {sectionHide?.enableDeliveryType && (
                                          <>
                                            <Select
                                              label={
                                                "Preferred Delivery Partner Rule"
                                              }
                                              formRegister={
                                                deliveryPartnerRegister
                                              }
                                              formError={deliveryPartnerError}
                                              formKey={
                                                "preferred_delivery_partner_rule"
                                              }
                                              optionsArray={[
                                                {
                                                  value: "1",
                                                  label: "Specific",
                                                },
                                              ]}
                                            />
                                            <Select
                                              label={
                                                "Preferred Delivery Partner"
                                              }
                                              formRegister={
                                                deliveryPartnerRegister
                                              }
                                              formError={deliveryPartnerError}
                                              formKey={
                                                "preferred_delivery_partner"
                                              }
                                              optionsArray={
                                                deliveryPartnerOptions?.preferred_delivery_partner
                                              }
                                            />
                                            <Input
                                              label={
                                                "Default Own Delivery Estimate (Mins)"
                                              }
                                              formRegister={
                                                deliveryPartnerRegister
                                              }
                                              formError={deliveryPartnerError}
                                              formKey={
                                                "partner_delivery_estimate"
                                              }
                                            />
                                          </>
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                            <div class="paddingtb10">
                              <div class="btns d-flex justify-content-end">
                                <button
                                  class="btn"
                                  name="submit"
                                  type="submit"
                                  id="cancel"
                                >
                                  Cancel
                                </button>
                                <button class="btn" name="submit" type="submit">
                                  Save
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mx-0">
            <div className="container px-0">
              <div className="shadowclass">
                <div className="col d-flex align-items-center">
                  <h4 className="event-alert"> Delivery Partners </h4>
                </div>{" "}
                <div className="row justify-content-between align-items-center w-100 mx-0"></div>
                <div className="table-responsive">
                  <table className="checklist-table remove-space inventory_table">
                    <thead>
                      <tr>
                        <th class="header">
                          <a href="">Partner Icon </a>
                        </th>
                        <th class="header">
                          <a href="">Partner Name</a>
                        </th>
                        <th class="header">
                          <a href="">Partner Merchant ID</a>
                        </th>
                        <th class="header">
                          Maximum Delivery Fee Paid by Merchant
                        </th>
                        <th class="header">Service Radius</th>
                        <th class="header">Time Range</th>
                        <th class="header">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {deliveryPartnerData?.delivery_partner?.map((el) => (
                        <tr>
                          <td>
                            <img
                              src={el?.partner_icon}
                              alt=""
                              className="rowImg"
                            />
                          </td>
                          <td>{el.partner_name}</td>
                          <td>{el.partner_merchant_id}</td>
                          <td>{el.maximum_delivery_fee}</td>
                          <td>{el.service_radius}</td>
                          <td>{el.start_time + " - " + el.end_time}</td>
                          <td>
                            <p
                              onClick={() => {
                                setModalType("edit");
                                setShowModal(true);
                                setEditData(
                                  deliveryPartnerData?.delivery_partner?.find(
                                    (item) => item?.id === el?.id
                                  )
                                );
                              }}
                              className="circle_icon edit_tooltip"
                            >
                              <i class="iconSprites edit-icon"></i>{" "}
                            </p>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div
                    onClick={() => {
                      setModalType("add");
                      setShowModal(true);
                    }}
                    class="col-sm-7 col-12 align-right px-0"
                  >
                    <p class="btn green-btn-revert add-plus mx-0">
                      <i class="i-icon"> </i> Add Table
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AddDeliveryPartner
          showModal={showModal}
          setShowModal={setShowModal}
          modalType={modalType}
          editData={editData}
        />
      </div>
    </UserInterface>
  );
};

const AddDeliveryPartner = ({
  showModal,
  setShowModal,
  modalType,
  editData,
}) => {
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);

  const dispatch = useDispatch();

  const deliveryPartnerOptions = useSelector(
    (state) => state?.settingReducer?.deliveryPartnerData
  );

  const addDefaultState = {
    partner_name: "",
    partner_merchant_id: "",
    maximum_delivery_fee: "",
    service_radius: "",
    start_time: "",
    maximum_delivery_fee: "",
    end_time: "",
    partner_icon: "",
  };

  const editDefaultState = {
    partner_name: editData?.partner_name,
    partner_merchant_id: editData?.partner_merchant_id,
    maximum_delivery_fee: editData?.maximum_delivery_fee,
    service_radius: editData?.service_radius,
    start_time: editData?.start_time,
    maximum_delivery_fee: editData?.maximum_delivery_fee,
    end_time: editData?.end_time,
    partner_icon: "",
  };
  useEffect(() => {
    if (modalType === "add") {
      reset(addDefaultState);
      return;
    }
    setStartTime(editData?.start_time);
    setEndTime(editData?.end_time);
    reset(editDefaultState);
  }, [modalType, editData]);

  const schema = yup.object().shape({
    partner_name: yup.string().required(),
    partner_merchant_id: yup.string().required(),
    maximum_delivery_fee: yup.string().required(),
    service_radius: yup.string().required(),
    start_time: yup.string().required(),
    maximum_delivery_fee: yup.string().required(),
    end_time: yup.string().required(),
    partner_icon: yup
      .mixed()
      .required()
      .test("type", "Only Image is supported", (value) => {
        console.log(value[0]?.type, value, "oooooo");
        return value?.[0]?.type === "image/png";
      }),
  });
  const submitData = (data) => {
    const submitData = getFormData({
      ...data,
      partner_icon: data.partner_icon[0],
      ordrr_online_id: deliveryPartnerOptions?.order_online?.id,
    });
    if (modalType == "add") dispatch(actions?.addDeliveryPartner(submitData));
    else
      dispatch(
        actions?.editDeliveryPartner({
          submitData: submitData,
          id: editData?.id,
        })
      );
  };
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: addDefaultState,
  });
  return (
    <ModelContainer
      title="Add Menu"
      open={showModal}
      closeModal={() => setShowModal(!showModal)}
      submitModal={handleSubmit(submitData)}
    >
      <form>
        <div className="form-list">
          <ul className="px-0">
            {/*edit account 1 */}
            {console.log(errors, "errors")}

            <Select
              label={"Partner Name"}
              formRegister={register}
              formError={errors}
              formKey="partner_name"
              optionsArray={deliveryPartnerOptions?.delivery_partners}
              isModal
            />
            <Input
              label={"Partner Merchant ID"}
              formRegister={register}
              formError={errors}
              formKey="partner_merchant_id"
              isModal
            />
            <Input
              label={"Maximum Delivery Fee Paid by Merchant"}
              formRegister={register}
              formError={errors}
              formKey="maximum_delivery_fee"
              isModal
            />
            <Input
              label={"Service Radius"}
              formRegister={register}
              formError={errors}
              formKey="service_radius"
              isModal
            />
            <TimeInput
              label={"Start Time"}
              formRegister={register}
              formError={errors}
              formKey="start_time"
              isModal
              timeVal={startTime}
              setTimeVal={setStartTime}
              setFormField={setValue}
            />

            <TimeInput
              label={"End Time"}
              formRegister={register}
              formError={errors}
              formKey="end_time"
              isModal
              timeVal={endTime}
              setTimeVal={setEndTime}
              setFormField={setValue}
            />
            <Input
              label={"Partner Icon"}
              formRegister={register}
              formError={errors}
              formKey="partner_icon"
              isModal
              type="file"
            />
          </ul>
        </div>
      </form>
    </ModelContainer>
  );
};

export default DeliveryPartner;
